// reach_ui/src/components/VastGPT/ChatMessages.js
import React from 'react'
import ChatMessage from './ChatMessage'

const ChatMessages = ({
  messages,
  given_name,
  family_name,
  loadingResponse,
  toolCallComponent,
}) => (
  <div className="chatContent" style={{ maxWidth: 900, margin: '0 auto' }}>
    {messages?.map((message, index) => (
      <ChatMessage
        key={`message${index}`}
        message={message}
        given_name={given_name}
        family_name={family_name}
        loadingResponse={loadingResponse}
        toolCallComponent={toolCallComponent}
      />
    ))}
  </div>
)

export default ChatMessages
